import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
	component:() => import('@/views/home/Home.vue')
  }, 
  {
	path: '/apply',
    name: 'apply',
	component:() => import('@/views/apply/Apply.vue')
  }
]

const router = new VueRouter({
	// mode:"history",
	routes,

})

router.beforeEach((to, form, next) => {
    if (to.meta.title) {
		document.title = to.meta.title;
    }
	next();
});


router.afterEach((to,from,next) => {
	window.scrollTo(0,0);
});
export default router
